import type { LegacyStaffEventBody, StaffEventBody } from 'src/observability/staffEventTypes';
import { apiHost, apiSecure } from 'src/util';

export const sendStaffEvent = (event: LegacyStaffEventBody | StaffEventBody) => {
  fetch(`http${apiSecure ? 's' : ''}://${apiHost}/observability/staffEvent`, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userType: 'provider',
      details: {},
      ...event,
      timestamp: (Date.now() / 1000).toFixed(0),
    }),
  });
};
